"use client";

import { Checkbox, Form, Input, InputNumber } from "antd";

import {
  ATTRIBUTE_TYPE,
  SYSTEM_ATTRIBUTE_PROPERTY,
} from "~/core/constants/attributes";

import { useInputKeyDown } from "../hooks/useInputKeyDown";
import { useGlobalCreateOpportunityStore } from "../store";

import ContactMultiSelect from "./FormItems/ContactMultiSelect";
import ContactSelect from "./FormItems/ContactSelect";
import DateWithFormItem from "./FormItems/Date";
import { MultiSelectWithFormItem } from "./FormItems/MultiSelect";
import { SelectWithFormItem } from "./FormItems/Select";
import TeamMemberSelect from "./FormItems/TeamMemberSelect";

/**
 *
 * @todo: need more refactor while working on UX improvement
 */

export const AdditionalFields = () => {
  const { handleKeyDown } = useInputKeyDown();

  const opportunityAttributes = useGlobalCreateOpportunityStore(
    state => state.opportunityAttributes,
  );

  return (
    <div className="space-y-4">
      {opportunityAttributes.map(attribute => {
        if (
          attribute.property_name ===
          SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_OWNER
        ) {
          return <TeamMemberSelect key={attribute.property_name} />;
        } else if (
          attribute.property_name ===
          SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_OTHER_STAKEHOLDERS
        ) {
          return <ContactMultiSelect key={attribute.property_name} />;
        } else if (
          attribute.property_name ===
          SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_CONTACT
        ) {
          return <ContactSelect key={attribute.property_name} />;
        } else if (attribute.attribute_type === ATTRIBUTE_TYPE.DATE) {
          return (
            <DateWithFormItem
              key={attribute.property_name}
              name={attribute.property_name}
              label={attribute.original_name}
            />
          );
        } else if (attribute.attribute_type === ATTRIBUTE_TYPE.MULTI_SELECT) {
          return (
            <MultiSelectWithFormItem
              key={attribute.property_name}
              arrtibuteName={attribute.property_name}
            />
          );
        } else if (attribute.attribute_type === ATTRIBUTE_TYPE.SELECT) {
          return (
            <SelectWithFormItem
              key={attribute.property_name}
              arrtibuteName={attribute.property_name}
            />
          );
        } else if (
          attribute.attribute_type === ATTRIBUTE_TYPE.STRING ||
          attribute.attribute_type === ATTRIBUTE_TYPE.LOCATION
        ) {
          return (
            <Form.Item
              key={attribute.property_name}
              name={attribute.property_name}
              label={attribute.original_name}
            >
              <Input.TextArea
                placeholder={`Enter ${attribute.current_name}`}
                onKeyDown={handleKeyDown}
                rows={2}
              />
            </Form.Item>
          );
        } else if (attribute.attribute_type === ATTRIBUTE_TYPE.EMAIL) {
          return (
            <Form.Item
              key={attribute.property_name}
              name={attribute.property_name}
              label={attribute.original_name}
            >
              <Input
                placeholder={`Enter ${attribute.current_name}`}
                onKeyDown={handleKeyDown}
              />
            </Form.Item>
          );
        } else if (attribute.attribute_type === ATTRIBUTE_TYPE.CHECKBOX) {
          return (
            <Form.Item
              key={attribute.property_name}
              name={attribute.property_name}
              label={attribute.original_name}
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          );
        } else if (attribute.attribute_type === ATTRIBUTE_TYPE.NUMBER) {
          return (
            <Form.Item
              key={attribute.property_name}
              name={attribute.property_name}
              label={attribute.original_name}
            >
              <InputNumber
                className="!w-full"
                placeholder={`Enter ${attribute.current_name}`}
                onKeyDown={handleKeyDown}
              />
            </Form.Item>
          );
        }

        return null;
      })}
    </div>
  );
};
